import { Fragment, useEffect, useState } from 'react';
import { Grid, Box, Typography, Card } from '@mui/material';
import { cardSection1, cardSection2, courseCard } from './styles';
import { useHistory } from 'react-router-dom';
import { type Course } from '../../utils/type';
import CourseReportDetailForm from './CourseReportDetailForm';
import { getAllCourses } from '../../api/apis';
import { ROUTES } from 'src/utils/constant';
import SearchInput from 'src/components/Input/SearchInput';
import PageLayout from 'src/components/Layout/PageLayout';

export const CourseReportListPage = () => {
  const history = useHistory();
  const [courses, setCourses] = useState<any>([]);
  const [filterCourses, setFilterCourses] = useState<Course[]>([]);
  const [filters, setFilters] = useState('');

  const getCourses = async () => {
    const response = await getAllCourses();
    const courseList = response.data.course;

    courseList.sort((a: Course, b: Course) => {
      if (a.category1 > b.category1) return 1;
      else if (a.category1 === b.category1) return 0;
      return -1;
    });
    setFilterCourses(courseList);
    setCourses(courseList);
  };

  useEffect(() => {
    setCourses([]);
    setFilterCourses([]);
    getCourses();
  }, []);

  useEffect(() => {
    if (!filters) {
      setFilterCourses(courses); return;
    }

    const allData = courses.filter((d: any) => d.category1.toLowerCase().indexOf(filters.toLowerCase()) >= 0);

    setFilterCourses(allData);
  }, [filters]);

  const renderAllCourses = () => {
    return filterCourses.map((course, index) => {
      const time = Math.floor(course.duration / 60);
      return (
        <Grid
          item
          xs={12}
          key={index}
          onClick={() => { history.push(`/course-report/${course.courseid}`); }}
          style={{ cursor: 'pointer' }}
        >
          <Card sx={courseCard}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Box sx={cardSection1}>
                  <div className="card-section1-content">
                    <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={course.thumbnail} />
                  </div>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                <Box sx={cardSection2}>
                  <div className="card-section2-main">
                    <Typography variant="h6" component="h2" color="#006EC2" className="card-section2-h">
                      {course.category1}
                      <span className="badge">Mandatory</span>
                    </Typography>
                  </div>
                  <Typography className="card-section2-desc" variant="h6" component="h2" color="#006EC2">
                    Time : {time} mins
                  </Typography>
                  <div style={{ wordBreak: 'break-word', marginTop: '6px' }}>{course.description}</div>
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      );
    });
  };

  return (
    <PageLayout
      topRight={
        <div style={{ display: 'flex', gap: '20px' }}>
          <SearchInput onTextChange={text => { setFilters(text); }} />
          <CourseReportDetailForm courses={courses} />
        </div>
      }
      title="Courses / Quizzes Report"
      arrow="right"
      isAdmin={true}
      onTitleClick={() => { history.push(ROUTES.missionReportList); }}
      report
    >
      <Grid container spacing={2} mt={2} mb={8}>
        {filterCourses instanceof Array && filterCourses.length > 0 && <Fragment>{renderAllCourses()}</Fragment>}
      </Grid>
    </PageLayout>
  );
};

export default CourseReportListPage;
